/* 4S collectiepagina (3-11-2026): filters, sorteren, zes weergaven, snel bekijken en vergelijken.
   4-11-2026 filters-fix: een collectie met meer dan 250 shirts staat op meerdere pagina's. Filters, sorteren
   en tellingen werkten alleen op de eerste pagina. Nu worden de andere pagina's op de achtergrond
   bijgeladen (sectie-weergave, zelfde kaarten) en geldt alles voor de hele collectie. ?sort_by= uit
   oude links (bijv. created-descending) zet de sortering.
   5-11-2026 (Sam: filters passen de shirts niet aan): in de weergave 'lijst' zette de CSS de kaarten op
   display:grid, waardoor weggefilterde kaarten (hidden) toch zichtbaar bleven. Een verborgen kaart is nu
   in elke weergave echt weg (regel bovenaan de stijl hieronder). */
(function () {
  var root = document.querySelector('[data-s4c]');
  if (!root) return;
  var lijst = root.querySelector('[data-lijst]');
  var kaarten = Array.prototype.slice.call(lijst.querySelectorAll('[data-kaart]'));
  var soort = root.dataset.soort;
  var gekozen = {};
  var verg = [];
  var sleutel = 's4-weergave';

  function ds(k, n) { return k.dataset[n] || ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function prijsband(p) { p = +p; return p < 350 ? 'a' : p < 700 ? 'b' : p <= 1000 ? 'c' : 'd'; }
  var bandNaam = { a: 'Onder € 350', b: '€ 350 tot € 700', c: '€ 700 tot € 1.000', d: 'Boven € 1.000' };
  var bewijsGroep = { fotovideo: 'beeld', video: 'beeld', foto: 'beeld', certificaat: 'certificaat', geen: 'geen', onbekend: 'onbekend' };
  var bewijsNaam = { beeld: 'Met foto of video', certificaat: 'Met certificaat', geen: 'Zonder certificaat', onbekend: 'Zie productpagina' };
  function decennium(k) { var j = +ds(k, 'jaar'); return j ? String(Math.floor(j / 10) * 10) : ''; }
  function decNaam(d) { return d ? "Jaren '" + d.slice(2) : ''; }

  /* Bepaal of dit een spelerpagina is: één speler in meer dan 60% van de shirts */
  if (soort === 'overig') {
    var tel = {};
    kaarten.forEach(function (k) { var s = ds(k, 'speler'); tel[s] = (tel[s] || 0) + 1; });
    var max = 0; for (var s in tel) if (tel[s] > max) max = tel[s];
    if (kaarten.length && max / kaarten.length > 0.6) soort = 'speler';
  }

  var groepen = [
    { id: 'bewijs', titel: 'Bewijs', waarde: function (k) { return bewijsGroep[ds(k, 'bewijs')] || 'onbekend'; }, naam: function (v) { return bewijsNaam[v]; }, volgorde: ['beeld', 'certificaat', 'geen', 'onbekend'] },
    { id: 'prijs', titel: 'Prijs', waarde: function (k) { return prijsband(ds(k, 'prijs')); }, naam: function (v) { return bandNaam[v]; }, volgorde: ['a', 'b', 'c', 'd'] },
    { id: 'speler', titel: 'Speler', waarde: function (k) { return ds(k, 'speler'); }, alfabet: true, verberg: soort === 'speler' },
    { id: 'team', titel: soort === 'competitie' ? 'Club' : 'Team', waarde: function (k) { return ds(k, 'team'); }, alfabet: true, verberg: soort === 'club' || soort === 'land' },
    { id: 'tijd', titel: 'Tijdperk', waarde: decennium, naam: decNaam, aflopend: false },
    { id: 'uitgever', titel: 'Certificaat van', waarde: function (k) { return ds(k, 'uitgever'); }, alfabet: true },
    { id: 'lijst', titel: 'Inlijsten', waarde: function (k) { return ds(k, 'lijst') === 'nee' ? '' : 'ja'; }, naam: function () { return 'Met lijst te bestellen'; } },
    { id: 'besch', titel: 'Beschikbaarheid', waarde: function (k) { return ds(k, 'beschikbaar') === '0' ? 'verkocht' : ''; }, naam: function () { return 'Ook verkochte shirts tonen'; } }
  ];
  groepen.forEach(function (g) { gekozen[g.id] = []; });

  function past(k, behalve) {
    for (var i = 0; i < groepen.length; i++) {
      var g = groepen[i];
      if (g.id === behalve || g.id === 'besch') continue;
      var keuze = gekozen[g.id];
      if (keuze.length && keuze.indexOf(g.waarde(k)) < 0) return false;
    }
    if (ds(k, 'beschikbaar') === '0' && gekozen.besch.indexOf('verkocht') < 0) return false;
    return true;
  }

  var groepenEl = root.querySelector('[data-groepen]');
  function bouwFilters() {
    var html = '';
    groepen.forEach(function (g) {
      if (g.verberg) return;
      var tel = {};
      kaarten.forEach(function (k) {
        var v = g.waarde(k); if (!v) return;
        if (g.id === 'besch' ? true : past(k, g.id)) tel[v] = (tel[v] || 0) + 1;
      });
      var waarden = Object.keys(tel);
      gekozen[g.id].forEach(function (v) { if (waarden.indexOf(v) < 0) { waarden.push(v); tel[v] = 0; } });
      if (!waarden.length || (waarden.length < 2 && g.id !== 'besch' && g.id !== 'lijst' && !gekozen[g.id].length)) return;
      if (g.volgorde) waarden.sort(function (a, b) { return g.volgorde.indexOf(a) - g.volgorde.indexOf(b); });
      else if (g.alfabet) waarden.sort(function (a, b) { return a.localeCompare(b, 'nl'); });
      else waarden.sort();
      var lang = waarden.length > 6;
      html += '<fieldset class="s4c-groep" data-groep="' + g.id + '"><legend>' + g.titel + '</legend>';
      waarden.forEach(function (v, i) {
        var aan = gekozen[g.id].indexOf(v) > -1;
        html += '<label' + (lang && i >= 6 && !aan ? ' data-extra hidden' : '') + '><input type="checkbox" value="' + esc(v) + '"' + (aan ? ' checked' : '') + '><span>' + esc(g.naam ? g.naam(v) : v) + '</span>' + (g.id === 'besch' ? '' : '<small>' + tel[v] + '</small>') + '</label>';
      });
      if (lang) html += '<button type="button" class="s4c-groep__meer" data-meer>Toon alle ' + waarden.length + '</button>';
      html += '</fieldset>';
    });
    groepenEl.innerHTML = html;
  }

  groepenEl.addEventListener('change', function (e) {
    var cb = e.target; if (cb.type !== 'checkbox') return;
    var g = cb.closest('[data-groep]').dataset.groep;
    var a = gekozen[g]; var i = a.indexOf(cb.value);
    if (cb.checked && i < 0) a.push(cb.value); if (!cb.checked && i > -1) a.splice(i, 1);
    pasToe();
  });
  groepenEl.addEventListener('click', function (e) {
    if (!e.target.matches('[data-meer]')) return;
    e.target.closest('fieldset').querySelectorAll('[data-extra]').forEach(function (l) { l.hidden = false; });
    e.target.remove();
  });

  var actiefEl = root.querySelector('[data-actief]');
  function bouwActief() {
    var html = '';
    groepen.forEach(function (g) {
      gekozen[g.id].forEach(function (v) {
        html += '<button type="button" class="s4c-chip" data-weg="' + g.id + '" data-v="' + esc(v) + '">' + esc(g.naam ? g.naam(v) : v) + ' <span aria-hidden="true">×</span><span class="visually-hidden">filter weghalen</span></button>';
      });
    });
    actiefEl.innerHTML = html;
    root.querySelectorAll('[data-wis]').forEach(function (b) { if (b.closest('.s4c-filters')) b.hidden = !html; });
  }
  actiefEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-weg]'); if (!b) return;
    var a = gekozen[b.dataset.weg]; a.splice(a.indexOf(b.dataset.v), 1); pasToe();
  });
  root.querySelectorAll('[data-wis]').forEach(function (b) {
    b.addEventListener('click', function () { groepen.forEach(function (g) { gekozen[g.id] = []; }); pasToe(); });
  });

  /* Sorteren */
  var sorteer = root.querySelector('[data-sorteer]');
  function sorteerKaarten() {
    var m = sorteer.value;
    var f = {
      'nieuw': function (a, b) { return ds(b, 'nieuw') - ds(a, 'nieuw'); },
      'prijs-op': function (a, b) { return ds(a, 'prijs') - ds(b, 'prijs'); },
      'prijs-af': function (a, b) { return ds(b, 'prijs') - ds(a, 'prijs'); },
      'jaar-op': function (a, b) { return (+ds(a, 'jaar') || 9999) - (+ds(b, 'jaar') || 9999); },
      'jaar-af': function (a, b) { return (+ds(b, 'jaar') || 0) - (+ds(a, 'jaar') || 0); },
      'speler': function (a, b) { return ds(a, 'speler').localeCompare(ds(b, 'speler'), 'nl'); }
    }[m];
    var rij = kaarten.slice();
    if (weergave === 'tijdlijn') rij.sort(function (a, b) { return (+ds(a, 'jaar') || 9999) - (+ds(b, 'jaar') || 9999); });
    else if (f) rij.sort(f);
    return rij;
  }
  sorteer.addEventListener('change', function () { pasToe(); });
  try {
    var sb = new URLSearchParams(location.search).get('sort_by');
    var sbMap = { 'created-descending': 'nieuw', 'price-ascending': 'prijs-op', 'price-descending': 'prijs-af', 'title-ascending': 'speler' };
    if (sb && sbMap[sb]) sorteer.value = sbMap[sb];
  } catch (e) {}

  /* Weergaven */
  var weergave = root.dataset.standaard || 'tegels';
  try { var w = localStorage.getItem(sleutel); if (w) weergave = w; } catch (e) {}
  var knoppen = root.querySelectorAll('[data-weergave]');
  knoppen.forEach(function (b) {
    b.addEventListener('click', function () { weergave = b.dataset.weergave; try { localStorage.setItem(sleutel, weergave); } catch (e) {} pasToe(); });
  });

  var bezigLaden = false;
  var toonKnop = null;
  var aantalEl = root.querySelector('[data-aantal]');
  var leegEl = root.querySelector('[data-leeg]');
  var muurtekst = root.querySelector('[data-muurtekst]');
  function pasToe() {
    knoppen.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.weergave === weergave ? 'true' : 'false'); });
    lijst.className = 's4c-lijst is-' + weergave;
    muurtekst.hidden = weergave !== 'muur';
    lijst.querySelectorAll('.s4c-tijdkop').forEach(function (x) { x.remove(); });
    var rij = sorteerKaarten();
    var n = 0, vorig = null;
    rij.forEach(function (k) {
      var ok = past(k);
      k.hidden = !ok;
      if (ok) {
        n++;
        if (weergave === 'tijdlijn') {
          var d = decennium(k);
          if (d !== vorig) {
            var kop = document.createElement('li');
            kop.className = 's4c-tijdkop';
            kop.innerHTML = '<b>' + (d || '—') + '</b><span>' + (d ? decNaam(d) : 'Seizoen niet vermeld') + '</span>';
            lijst.appendChild(kop);
            vorig = d;
          }
        }
      }
      lijst.appendChild(k);
    });
    aantalEl.textContent = n + (n === 1 ? ' shirt' : ' shirts') + (bezigLaden ? ' (meer shirts worden geladen)' : '');
    leegEl.hidden = n > 0;
    if (toonKnop) toonKnop.textContent = n ? 'Toon ' + n + (n === 1 ? ' shirt' : ' shirts') : 'Geen shirts, pas de filters aan';
    bouwFilters();
    bouwActief();
  }

  /* Filters op telefoon. 4-11-2026 filters-fix: het paneel lag onder de nieuwsband, de cadeau-badge en de
     WhatsApp-knop, waardoor de sluitknop en de onderste filters niet te bereiken waren. Nu ligt het paneel
     boven alles, met een donkere achtergrond (tik = sluiten), Escape sluit, en onderaan staat een knop
     'Toon N shirts' die het paneel sluit en naar de resultaten gaat. */
  var filtersEl = root.querySelector('[data-filters]');
  var fk = root.querySelector('[data-filterknop]');
  var stijl = document.createElement('style');
  stijl.textContent = '.s4c-lijst [data-kaart][hidden],.s4c-lijst>[hidden]{display:none!important}'
    + '@media screen and (max-width:989px){.s4c-filters{z-index:9001!important}'
    + '.s4c-filterscherm{position:fixed;inset:0;background:rgba(11,10,9,.45);z-index:9000;display:block!important}'
    + '.s4c-filters__toon{position:sticky;bottom:-2rem;margin:auto -2rem -2rem;padding:1.2rem 2rem calc(1.2rem + env(safe-area-inset-bottom));background:#fff;border-top:1px solid rgba(11,10,9,.12)}'
    + '.s4c-filters__toon button{width:100%;min-height:4.8rem;background:#0B0A09;color:#F5F1EA;border:0;border-radius:4px;font:inherit;font-size:1.5rem;font-weight:600;cursor:pointer}'
    + 'html.s4c-filters-open{overflow:hidden}}'
    + '@media screen and (min-width:990px){.s4c-filters__toon,.s4c-filterscherm{display:none!important}}'
    + '.s4c-filterscherm[hidden]{display:none!important}';
  document.head.appendChild(stijl);
  var scherm = document.createElement('div');
  scherm.className = 's4c-filterscherm';
  scherm.hidden = true;
  document.body.appendChild(scherm);
  var toonBlok = document.createElement('div');
  toonBlok.className = 's4c-filters__toon';
  toonBlok.innerHTML = '<button type="button" data-toon>Toon shirts</button>';
  filtersEl.appendChild(toonBlok);
  toonKnop = toonBlok.querySelector('[data-toon]');
  function openFilters() {
    filtersEl.classList.add('is-open'); fk.setAttribute('aria-expanded', 'true');
    scherm.hidden = false; document.documentElement.classList.add('s4c-filters-open');
  }
  function sluitFilters(naar) {
    filtersEl.classList.remove('is-open'); fk.setAttribute('aria-expanded', 'false');
    scherm.hidden = true; document.documentElement.classList.remove('s4c-filters-open');
    if (naar === 'resultaten') {
      var balkEl = root.querySelector('.s4c-balk');
      if (balkEl) window.scrollTo({ top: balkEl.getBoundingClientRect().top + window.pageYOffset - 140 });
    } else if (naar === 'knop') fk.focus();
  }
  fk.addEventListener('click', openFilters);
  root.querySelector('[data-filtersluit]').addEventListener('click', function () { sluitFilters('knop'); });
  scherm.addEventListener('click', function () { sluitFilters('knop'); });
  toonKnop.addEventListener('click', function () { sluitFilters('resultaten'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && filtersEl.classList.contains('is-open')) sluitFilters('knop'); });

  /* Snel bekijken */
  var snel = root.querySelector('[data-snelvenster]');
  function opent(dlg) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
  function sluit(dlg) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  lijst.addEventListener('click', function (e) {
    var b = e.target.closest('[data-snel]'); if (!b) return;
    var k = b.closest('[data-kaart]');
    var fotos = ds(k, 'fotos').split('|').filter(Boolean);
    var varianten = []; try { varianten = JSON.parse(ds(k, 'varianten')); } catch (x) {}
    var eerste = varianten.filter(function (v) { return v.a; })[0] || varianten[0];
    var html = '<div class="s4c-snel"><div class="s4c-snel__fotos">' + fotos.map(function (f) { return '<img src="' + esc(f) + '" alt="' + esc(ds(k, 'titel')) + '" loading="lazy">'; }).join('') + '</div>';
    html += '<div class="s4c-snel__tekst"><div class="s4c-snel__kop"><p class="s4c-eyebrow">Snel bekijken</p><button type="button" class="s4c-sluit" data-sluit aria-label="Sluiten">×</button></div>';
    html += '<h2>' + esc(ds(k, 'speler')) + '</h2><p style="margin:0;font-size:1.4rem;color:#3D372E">' + esc([ds(k, 'team'), ds(k, 'seizoen')].filter(Boolean).join(' · ')) + '</p>';
    html += '<span class="s4c-snel__bewijs">' + esc(ds(k, 'bewijslang')) + (ds(k, 'uitgever') ? ' (' + esc(ds(k, 'uitgever')) + ')' : '') + '</span>';
    if (varianten.length > 1) {
      html += '<fieldset class="s4c-snel__opties"><legend class="visually-hidden">Uitvoering</legend>' + varianten.map(function (v) { return '<label><input type="radio" name="s4c-variant" value="' + v.id + '" data-p="' + esc(v.p) + '"' + (v === eerste ? ' checked' : '') + (v.a ? '' : ' disabled') + '>' + esc(v.t) + (v.a ? '' : ' (verkocht)') + '</label>'; }).join('') + '</fieldset>';
    }
    html += '<p class="s4c-snel__prijs" data-snelprijs>' + esc(eerste ? eerste.p : '') + '</p>';
    html += '<div class="s4c-snel__acties">' + (eerste && eerste.a ? '<button type="button" class="s4c-knop" data-voegtoe>In winkelwagen</button>' : '<span>Dit shirt is verkocht.</span>') + '<a href="' + esc(ds(k, 'url')) + '" style="text-decoration:underline;font-size:1.4rem">Alle details</a></div><p class="s4c-snel__melding" data-melding aria-live="polite"></p></div></div>';
    snel.innerHTML = html;
    snel.dataset.vid = eerste ? eerste.id : '';
    opent(snel);
  });
  snel.addEventListener('click', function (e) {
    if (e.target === snel || e.target.closest('[data-sluit]')) { sluit(snel); return; }
    var t = e.target.closest('[data-voegtoe]'); if (!t) return;
    var r = snel.querySelector('input[name="s4c-variant"]:checked');
    var id = r ? r.value : snel.dataset.vid;
    t.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
      .then(function () { snel.querySelector('[data-melding]').innerHTML = 'Toegevoegd. <a href="/cart" style="text-decoration:underline">Naar de winkelwagen</a>'; })
      .catch(function (err) { t.disabled = false; snel.querySelector('[data-melding]').textContent = (err && err.description) || 'Toevoegen lukte niet. Probeer het op de productpagina.'; });
  });
  snel.addEventListener('change', function (e) { if (e.target.name === 's4c-variant') snel.querySelector('[data-snelprijs]').textContent = e.target.dataset.p; });

  /* Vergelijken */
  var balk = root.querySelector('[data-vergbalk]');
  var vergvenster = root.querySelector('[data-vergvenster]');
  lijst.addEventListener('change', function (e) {
    if (!e.target.matches('[data-vergelijk]')) return;
    var k = e.target.closest('[data-kaart]'); var i = verg.indexOf(k);
    if (e.target.checked) { if (verg.length >= 3) { e.target.checked = false; alertBalk('Je kunt maximaal 3 shirts vergelijken.'); return; } if (i < 0) verg.push(k); }
    else if (i > -1) verg.splice(i, 1);
    toonBalk();
  });
  function alertBalk(t) { root.querySelector('[data-vergtekst]').textContent = t; }
  function toonBalk() {
    balk.hidden = verg.length === 0;
    root.querySelector('[data-vergtekst]').textContent = 'Vergelijk ' + verg.length + ' van max. 3';
    root.querySelector('[data-verglijst]').innerHTML = verg.map(function (k) { var f = ds(k, 'fotos').split('|')[0]; return '<span>' + (f ? '<img src="' + esc(f) + '" alt="">' : '') + esc(ds(k, 'speler')) + '</span>'; }).join('');
    root.querySelector('[data-vergopen]').disabled = verg.length < 2;
  }
  root.querySelector('[data-vergwis]').addEventListener('click', function () { verg.forEach(function (k) { k.querySelector('[data-vergelijk]').checked = false; }); verg = []; toonBalk(); });
  root.querySelector('[data-vergopen]').addEventListener('click', function () {
    var rijen = [
      ['', function (k) { var f = ds(k, 'fotos').split('|')[0]; return f ? '<img src="' + esc(f) + '" alt="' + esc(ds(k, 'titel')) + '">' : ''; }],
      ['Speler', function (k) { return '<b>' + esc(ds(k, 'speler')) + '</b>'; }],
      ['Team', function (k) { return esc(ds(k, 'team')); }],
      ['Seizoen', function (k) { return esc(ds(k, 'seizoen')); }],
      ['Bewijs', function (k) { return esc(ds(k, 'bewijslang')); }],
      ['Certificaat van', function (k) { return esc(ds(k, 'uitgever')); }],
      ['Inlijsten', function (k) { var l = ds(k, 'lijst'); return l === 'ja' ? 'Met of zonder lijst' : l === 'ingelijst' ? 'Ingelijst' : 'Zonder lijst'; }],
      ['Prijs', function (k) { return esc(k.querySelector('.s4c-kaart__prijs').textContent); }],
      ['', function (k) { return '<a class="s4c-knop" href="' + esc(ds(k, 'url')) + '">Bekijk shirt</a>'; }]
    ];
    var html = '<div class="s4c-verg"><div class="s4c-snel__kop"><h2 class="s4c-h2" style="margin:0">Vergelijken</h2><button type="button" class="s4c-sluit" data-sluit aria-label="Sluiten">×</button></div><table>';
    rijen.forEach(function (r) { html += '<tr><th scope="row">' + r[0] + '</th>' + verg.map(function (k) { return '<td>' + r[1](k) + '</td>'; }).join('') + '</tr>'; });
    vergvenster.innerHTML = html + '</table></div>';
    opent(vergvenster);
  });
  vergvenster.addEventListener('click', function (e) { if (e.target === vergvenster || e.target.closest('[data-sluit]')) sluit(vergvenster); });

  /* Andere pagina's van de collectie bijladen, zodat filters en sorteren voor alle shirts gelden */
  function telKop() {
    var b = root.querySelectorAll('.s4c-kop__cijfers b');
    if (!b.length) return;
    var besch = kaarten.filter(function (k) { return ds(k, 'beschikbaar') === '1'; });
    var spelers = {}, beeld = 0, cert = 0, geen = 0;
    besch.forEach(function (k) {
      spelers[ds(k, 'speler')] = 1;
      var g = bewijsGroep[ds(k, 'bewijs')];
      if (g === 'beeld') beeld++; else if (g === 'certificaat') cert++; else if (g === 'geen') geen++;
    });
    b[0].textContent = besch.length;
    if (b.length === 3) b[1].textContent = Object.keys(spelers).length;
    if (b.length > 1) b[b.length - 1].textContent = beeld + ' · ' + cert + ' · ' + geen;
  }
  function laadRest() {
    var pag = root.querySelector('.pagination-wrapper') || root.querySelector('.pagination');
    var sectie = root.closest('[id^="shopify-section-"]');
    if (!pag || !sectie || !window.fetch || !window.DOMParser) return;
    var sid = sectie.id.replace('shopify-section-', '');
    var max = 1;
    pag.querySelectorAll('a[href]').forEach(function (a) { var m = a.getAttribute('href').match(/[?&]page=(\d+)/); if (m) max = Math.max(max, +m[1]); });
    var nu = +(new URLSearchParams(location.search).get('page') || 1);
    var paginas = [];
    for (var p = 1; p <= Math.max(max, nu); p++) if (p !== nu) paginas.push(p);
    if (!paginas.length) return;
    var gezien = {};
    kaarten.forEach(function (k) { gezien[ds(k, 'url')] = 1; });
    bezigLaden = true;
    pasToe();
    Promise.all(paginas.map(function (p) {
      var q = new URLSearchParams(location.search);
      q.set('page', p); q.set('section_id', sid);
      return fetch(location.pathname + '?' + q.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (stukken) {
      var nieuw = 0;
      stukken.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-kaart]').forEach(function (k) {
          var u = k.getAttribute('data-url');
          if (gezien[u]) return;
          gezien[u] = 1;
          var kn = document.importNode(k, true);
          lijst.appendChild(kn);
          kaarten.push(kn);
          nieuw++;
        });
      });
      bezigLaden = false;
      if (nieuw) { pag.hidden = true; pag.style.display = 'none'; telKop(); }
      pasToe();
    });
  }

  pasToe();
  laadRest();
})();
